import type { UpdateLocationModalData } from ".";
import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/shared/uikit/Button";
import { Modal } from "@circle-react-uikit/ModalV2";

interface FooterProps {
  hasLocation: boolean;
  onCancel: () => void;
}

export const Footer = ({ hasLocation, onCancel }: FooterProps) => {
  const { watch } = useFormContext<UpdateLocationModalData>();
  const location = watch("location");

  const isSubmitDisabled = typeof location === "string" || !location;
  return (
    <Modal.Footer className="mt-8 flex items-center justify-end gap-4">
      <Button type="button" variant="secondary" onClick={onCancel}>
        {hasLocation
          ? t("filters.near_me.with_location.cancel")
          : t("filters.near_me.no_location.cancel")}
      </Button>
      <Button type="submit" variant="primary" disabled={isSubmitDisabled}>
        {hasLocation
          ? t("filters.near_me.with_location.submit")
          : t("filters.near_me.no_location.submit")}
      </Button>
    </Modal.Footer>
  );
};
